import styled from "styled-components";
import { ReactComponent as TimeIcon } from "Components/common/assets/time.svg";
import { ReactComponent as RefreshIcon } from "Components/common/assets/refresh.svg";

export const LastUpdatedWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
`;

export const LastUpdatedText = styled.span`
  color: #606060;
  display: inline-flex;
  align-items: center;
`;

export const RefreshLink = styled.a`
  display: inline-flex;
  align-items: center;
  color: #3f7f7d;
  cursor: pointer;
  text-decoration: none;
  font-weight: 700;
  margin-left: 16px;
  margin-right: 16px;
`;

export const HeaderStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const TitleStyled = styled.div`
  font-family: "Readex Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  min-width: 250px;
  cursor: default;
`;

export const HeaderControlsStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const TimeIconStyled = styled(TimeIcon)`
  margin-right: 8px;
  vertical-align: middle;
`;

export const RefreshIconStyled = styled(RefreshIcon)`
  margin-right: 8px;
  vertical-align: middle;
`;
